'use strict'

import deepFreeze from 'deep-freeze'
import config from 'app/fs/config'

var initialState = deepFreeze({
  base: {
    active: false,
    promptToCloseActive: false,
    currentlyEditingAttr: null, //'link_url',
    imageMetadata: {},
    linkLocationMetadata: {},
    waitingForImage: false,
    uploading: false,
    uploadingFailed: false,
    pendingPhotoFilename: null,
    submitOnUploadComplete: false,
    submitting: false,
    failed: false,
    featuredHashTagInitialied: null,
    featuredHashTag: null,
    uploadAttemptCount: 0,
    validatingRemotely: false,

    proceedInBackground: false,

    processingRemoteImage: false,

    errorMessage: null,
    errorMessageDismissed: true,

    existingLinkPostIds: [],
    post: {
      user_level_tag_ids: [],
      profile_type_ids: [],
      challenge_group_ids: [],
      post_type_ids: [],
      image_url: null,
      //image_url: config.sampleImage,
      link_url: null,
      title: '',
      description: '',
      offer: '',
      post_ingredients_attributes: [],
      start_date: null,
      end_date: null
    },

    shareVia: {
      facebook: false,
      instagram: false,
      twitter: false
    }
  },

  location: {
    geocodeQueryLoading: false,
    geocodeQueryFailed: false,
    geocodeQuery: null,

    locationQueryLoading: false,
    locationQueryFailed: false,
    locationQuery: null,

    photoLocation: null,
    selectedLocationType: 'photo',
    geocodeFocused: false,

    selectedGeocodeName: null, // Just a placeholder until something meaningful shows up
    selectedGeocodeLatitude: null,
    selectedGeocodeLongitude: null,

    persistingLocationInProgress: false,
    persistingLocationFailed: false,

    selectedLocationId: null
  },

  ingredients: {
    query: null,
    reviewing: false,
    selectedIngredientIds: [],
    visibleIngredientIds: [],
    focusedIngredientId: null,
    focusedIngredientLevelTagId: null,
    ingredientLevelTagTipVisible: false,
    ingredientLevelTagIds: {},
    newIngredientIds: [],
    ingredientsAddedAt: {}
  },

  tags: {
    loading: true,
    query: '',
    allTagIds: [],
    visibleChallengeGroupIds: [],
    selectedTagIds: []
  }
})

export default initialState
